module.exports = __webpack_public_path__ + "img/isPro1_3.6e872ec8.png";